export default __webpack_public_path__ + "static/media/link-grey.7fbafc44.svg";